import * as currency from '@shopify/theme-currency';
import * as themeProduct from '@shopify/theme-product';
import { getUrlWithVariant, ProductForm } from '@shopify/theme-product-form';
import { URLParams, slickHelpers, getImageFilenameWithoutExtension } from '../utils/helpers';
import vuePDPComponents from './pdp/vue-components';

import { showCartSideDraw } from "../sections/cart-drawer";
import { addToCart } from "../utils/add-to-cart";
import { init as boldSubscriptionInit } from "./pdp/bold-subscription-widget";
import { getSampleButtonText, shouldDisabledSampleButton, updateCartCounter, updateSampleButtonText } from "../components/product-samples/product-samples";
import { updateCartWarning } from './cart';
// #417 / #689 — per-state stock indicator + ATC gating
import ProductStockByState from '../components/product-stock-by-state/product-stock-by-state';
// import { changeProductSliderImageToMatchSwatch } from "./pdp/colour-swatch-options";

const nextArrow = `<button class="slick-next slick-arrow" aria-label="Previous" type="button">
                      <svg class="slick-arrow-svg slick-arrow-svg-right light" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 40 40">
                      <g fill="none" fill-rule="evenodd">
                          <circle cx="20" cy="20" r="20" fill="#31363c" stroke="rgba(94, 116, 142, 0.5)"/>
                          <g stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                              <path d="M11.25 5.25L18.842 12 11.25 18.75M18 12L6 12" transform="translate(9 8)"/>
                          </g>
                      </g>
                      </svg>
                      </button>
                      `;

const prevArrow = `<button class="slick-prev slick-arrow" aria-label="Next" type="button">
                      <svg class="slick-arrow-svg slick-arrow-svg-left light" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 40 40">
                      <g fill="none" fill-rule="evenodd">
                          <circle cx="20" cy="20" r="20" fill="#31363c" stroke="rgba(94, 116, 142, 0.5)"/>
                          <g stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                              <path d="M5.25 0L12.842 6.75 5.25 13.5M12 6.75L0 6.75" transform="matrix(-1 0 0 1 26.5 13.25)"/>
                          </g>
                      </g>
                      </svg>
                      </button>`;

const PDP = () => {
  if (!document.querySelector('.pdp-template')) {
    return false;
  }

  $(document).on('DOMContentLoaded', () => {
    $('.product-hero__inner').addClass('is-loaded');
    // Update: we brought back the Colour Options Dropdown as a fallback when Colour Swatches are not available
    // Check if .colour-option-swatch exists
    if ($('.colour-option-swatch').length) {
      // hide nice select dropdown
      $('.colour-option-select').css('display', 'none');
    }
  });

  $('.product-hero__slider-inner').on(
    'beforeChange',
    (event, slick, currentSlide, nextSlide) => {
      $('.product-hero__thumbnails').slick('slickGoTo', nextSlide);
    }
  );
  $('.product-hero__slider-inner').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.product-hero__thumbnails',
    arrows: false,
    fade: true,
    dots: false,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    adaptiveHeight: true,
    draggable: false,
    lazyLoad: 'progressive',
    infinite: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          dots: true,
        },
      },
    ],
  });

  $('.product-hero__thumbnails').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.product-hero__slider-inner',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    infinite: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 992,
        settings: 'unslick',
      },
    ],
  });

  slickHelpers.handleResponsiveSlider($('.product-hero__thumbnails'), 992);

  let shopifyProductForm, globalProductJSON, globalSampleJSON, qtyIndex, sizeOrDenominationsIndex, colourIndex;
  let pdpComponent = new vuePDPComponents();
  let selectedVariant = null,
    selectedVariantID,
    productQuantity,
    productVariants,
    compareAtPriceV2,
    currentProductPriceV2,
    noVariantExists = false;

  const els = {
    productSlides: 'div.product-hero__slider-image',
    form: {
      formElement: document.querySelector('[data-product-form]'),
      productHandle: document.querySelector('[data-product-form]').dataset
        .productHandle,
      sampleHandle: document.querySelector('[data-product-form]').dataset
        .sampleHandle,
      sampleKit: document.querySelector('[data-product-form]').dataset.sampleKit,
      sampleKitWeight: document.querySelector('[data-product-form]').dataset.sampleKitWeight,
      addToCart: document.querySelector('#AddToCart'),
      addToCartText: document.querySelector('#AddToCart--text'),
      addToCartIcon: document.querySelector('#AddToCart--icon'),
      klaviyoBisButton: document.querySelector('.klaviyo-bis-trigger'),
      price: '.price-amount',
      comparePrice: '.compare-at-price',
    },
    options: {
      colorSwatches: document.querySelectorAll('.color-option'),
      sizeBoxes: document.querySelectorAll('.box-option'),
      lengthDropDown: document.querySelectorAll('.styled-dropdown-option'),
    },
    buttons: {
      increaseQty: document.querySelector("#quantity-increase"),
      decreaseQty: document.querySelector("#quantity-decrease"),
      addToCompare: document.querySelector(
        '.product-hero__details-footer__compare > .badge'
      ),
    },
    quantityInput: document.querySelector('#quantity'),
    cartDrawer: '.cart-drawer-section-wrapper',
  };

  pdpProductForm();
  pdpImageZoom();
  bindClickEvents();
  ProductStockByState();
  pdpComponent.compareBadge();
  pdpComponent.sampleBadge();
  pdpComponent.relatedProductSlider();
  document.addEventListener('DOMContentLoaded', function () {
    setKlaviyoOutOfStockModal();
  });

  async function pdpProductForm() {
    let productJSON = await fetchProductJson();
    globalProductJSON = productJSON;
    let sampleJSON = await fetchSampleProductJson();
    globalSampleJSON = sampleJSON;
    qtyIndex = globalProductJSON.options.findIndex(
      (option) => option.name === 'Qty'
    );
    sizeOrDenominationsIndex = globalProductJSON.options.findIndex((option) =>
      ['Size', 'Denominations'].includes(option.name)
    );
    colourIndex = globalProductJSON.options.findIndex(
      (option) => option.name === 'Colour'
    );
    let variants = productJSON.variants;
    let productCompareAtPrice = productJSON.compare_at_price;

    shopifyProductForm = new ProductForm(els.form.formElement, productJSON, {
      onOptionChange,
      onQuantityChange,
    });

    productQuantity = shopifyProductForm.quantity();

    if (URLParams('variant') !== null) {
      // 1. Check if the URL contains a Specific Variant ID.
      // Check the QueryString to set Selected Variant
      selectedVariantID = URLParams('variant');
      productVariants = variants;
      selectedVariant = variants.filter(
        (variant) => variant.id.toString() === selectedVariantID.toString()
      );
      selectedVariant = selectedVariant[0];
    } else if (productCompareAtPrice !== null) {
      // 2. Check if the Product Is On Sale
      // Update the UI to Display the On Sale Price
      // Setting the First Available Variant
      productVariants = variants;

      // Next, we filter through variants and return
      // the variant that has a Compare At Price
      let variantOnSale = productVariants.filter(
        (variant) => variant.compare_at_price !== null
      );

      selectedVariant = variantOnSale[0];
      selectedVariantID = variantOnSale[0].id;
      currentProductPriceV2 = variantOnSale[0].price;
      compareAtPriceV2 = variantOnSale[0].compare_at_price;
    } else if (variants.length == null || variants.length == 0) {
      // Check if Any Variants Exist
      console.warn('No Variants');
    } else {
      // Setting the First Available Variant
      productVariants = variants;
      selectedVariant = variants[0];
      selectedVariantID = variants[0].id;
      currentProductPriceV2 = variants[0].price;
      compareAtPriceV2 = variants[0].compare_at_price;
    }

    updateProductFormUIOnLoad(selectedVariant);
    updateWindowHistory(selectedVariantID);
  }

  async function fetchProductJson() {
    let response = await $.getJSON(`/products/${els.form.productHandle}.js`)
      .done((productJSON) => {
        return productJSON;
      })
      .fail((err) => {
        console.error('Error:', err);
      });

    return response;
  }

  async function fetchSampleProductJson() {
    if (!els.form.sampleHandle) {
      return null;
    }
    let response = await $.getJSON(`/products/${els.form.sampleHandle}.js`)
      .done((productJSON) => {
        return productJSON;
      })
      .fail((err) => {
        console.error('Error:', err);
      });

    return response;
  }

  function updateSampleSelection() {
    if (els.form.sampleHandle && globalSampleJSON) {
      const currentOptions = shopifyProductForm.options();
      const selectedOptions = currentOptions
        .filter((option) => option.name !== 'Qty')
        .map((option) => option.value);

      const selectedSampleVariant =
        themeProduct.getVariantFromOptionArray(
          globalSampleJSON,
          selectedOptions
        );

      // set data-sample-variant-id
      if (selectedSampleVariant) {
        document.querySelector('[data-sample-variant-id]').setAttribute('data-sample-variant-id', selectedSampleVariant.id);
        updateCartCounter();
        const text = getSampleButtonText(selectedSampleVariant.id, els.form.sampleKit, els.form.sampleKitWeight);
        updateSampleButtonText(text, shouldDisabledSampleButton(text));
      }
    }
  }

  function onOptionChange(event) {

    updateSampleSelection();
    const variant = event.dataset.variant;
    const qty = event.dataset.quantity;

    // Update Product Options
    // Check if variant exists, if not find next available
    const currentOptions = shopifyProductForm.options();
    const selectedOptions = currentOptions.map((option) => option.value);
    const productVariants = globalProductJSON.variants.map(
      (variant) => variant
    );
    const findVariantBySelectedOptions = (
      variants,
      functionSelectedOptions
    ) => {
      const find = variants.find((variant) =>
        functionSelectedOptions.every((option, i) => {
          return option === variant.options[i];
        })
      );
      return find
        ? find
        : findVariantBySelectedOptions(
          variants,
          functionSelectedOptions.slice(0, functionSelectedOptions.length - 1)
        );
    };

    let getProductVariantBasedOnSelectedOptions =
      themeProduct.getVariantFromOptionArray(
        globalProductJSON,
        selectedOptions
      );

    if (!getProductVariantBasedOnSelectedOptions) {
      // Find first variant based on selected input
      const selectedOptionName = event.target.getAttribute('data-option-name');
      const selectedOption = globalProductJSON.options.find(
        (option) => option.name === selectedOptionName
      );

      if (selectedOption === undefined) {
        els.form.addToCart.textContent = 'Not Available';
        els.form.addToCart.disabled = true;
        // Force disable with a small delay to catch any race conditions
        setTimeout(() => {
          els.form.addToCart.disabled = true;
        }, 100);
        return false;
      }

      const selectedOptionKey = `option${selectedOption.position}`;
      const selectedOptionValue = event.dataset.options.find(
        (option) => option.name === selectedOptionName
      ).value;

      const suggestedVariant = productVariants.filter((productVariant) => {
        return productVariant[selectedOptionKey] === selectedOptionValue;
      });

      if (suggestedVariant.length > 1) {
        // don't suggest
        els.form.addToCart.textContent = 'Not Available';
        els.form.addToCart.disabled = true;
      } else {
        // Check if the Product Is available for Purchase
        setProductAvailablity(suggestedVariant[0], qty);
        updateProductOptionsv3(suggestedVariant[0]);
      }
    } else {
      els.form.addToCart.textContent = 'Add to Bag';
      els.form.addToCart.disabled = false;
      // Check if the Product Is available for Purchase
      setProductAvailablity(getProductVariantBasedOnSelectedOptions, qty);
      updateProductOptionsv3(getProductVariantBasedOnSelectedOptions);
    }

    // Update History
    if (variant) {
      updateWindowHistory(variant.id);
    }
  }

  function onQuantityChange(event) {
    // This function checks the
    // quantity, and update pricing
    const qty = event.dataset.quantity;

    if (event.target.id == 'quantity-increase') {
      value = isNaN(value) ? 1 : value;
      value++;
    } else if (event.target.id == 'quantity-decrease') {
      value = isNaN(value) ? 1 : value;
      value--;
    }

    // Update Global Variable
    productQuantity = qty;

    // Update Product Price
    updateProductPrices(
      productQuantity,
      currentProductPriceV2,
      compareAtPriceV2
    );
  }

  function pdpImageZoom() {
    $(els.productSlides).zoom({
      on: 'mouseover',
      duration: 250,
      magnify: 1.25,
    });
  }

  function bindClickEvents() {
    els.buttons.increaseQty &&
      els.buttons.increaseQty.addEventListener(
        'click',
        handleQuantityInputChange
      );
    els.buttons.decreaseQty &&
      els.buttons.decreaseQty.addEventListener(
        'click',
        handleQuantityInputChange
      );
    els.form.addToCart &&
      els.form.addToCart.addEventListener('click', (e) => {
        e.preventDefault();
        const productHandle = els.form.productHandle;
        const callback = {
          success: () => {
            updateCartCounter();
            showCartSideDraw();
            setTimeout(() => {
              updateCartWarning();
            }, 1500);
          },
        };

        boldSubscriptionInit(els.form.formElement);
        const selectedVariantIDFromURL = URLParams('variant');
        addToCart({
          quantity: productQuantity,
          productHandle,
          selectedVariantID: selectedVariantIDFromURL || selectedVariant,
          callback,
        });
      });

    // ================
    // Styled Dropdowns
    // ================
    $('.styled-dropdown-item').on('click', function () {
      // let dataValue = $(this).data('length-value');
      let dataValue = $(this).data('size-value');

      // Updated Hidden Select Field For Product Form JS
      // Checking the Length Product Options Dropdown
      $('option:selected', 'select[name="options[Length]"]').removeAttr(
        'selected'
      );

      $('select[name="options[Length]"]')
        .find(`option[value="${dataValue}"]`)
        .attr('selected', true);

      let changeEvent = new Event('change');
      document
        .querySelector('[name="options[Length]"]')
        .dispatchEvent(changeEvent);

      // Checking the New Size Product Options Dropdown
      $('option:selected', 'select[name="options[Size]"]').removeAttr(
        'selected'
      );

      $('select[name="options[Size]"]')
        .find(`option[value="${dataValue}"]`)
        .attr('selected', true);

      document
        .querySelector('[name="options[Size]"]')
        .dispatchEvent(changeEvent);
    });

    // =============================
    // Variant Colour Options Dropdown
    // =============================
    // set a flag to keep track if the change event has already been fired

    $('.colour-option-select').niceSelect({
      afterRender: function () {
        let colourSelect = $('.nice-select.colour-option-select');
        if (colourSelect.children('li').length <= 1) {
          colourSelect.addClass('disabled');
        } else {
          colourSelect.removeClass('disabled');
        }
      },
    });

    let swatchState = { hasImageAdded: false };
    let isChangeEventFired = false;

    $('select.colour-option-select').on('change', function () {
      // check if the change event has already been fired
      if (!isChangeEventFired) {
        // set the flag to true to indicate that the change event has been fired
        isChangeEventFired = true;

        let selectedOption = $(this).find(':selected');
        let dataValue = selectedOption.data('colour-value');

        // Maniplulate the UI
        $('[data-selected-colour]').text(dataValue);
        let changeEvent = new Event('change');
        document
          .querySelector('[name="options[Colour]"]')
          .dispatchEvent(changeEvent);

        // call the changeProductSliderImageToMatchSwatch function only if the flag is false
        // changeProductSliderImageToMatchSwatch($(this));
        updateSlickSliderOnSwatchSelect(colourIndex, dataValue, swatchState);

        // reset the flag to false
        isChangeEventFired = false;
      }
    });

    // =============================
    // Variant Colour Swatch Options
    // =============================
    $('.colour-option').on('click', function () {
      let _this = $(this);

      let dataValue = _this.data('colour-value');

      // Maniplulate the UI
      $('[data-selected-colour]').text(dataValue);
      $('.colour-option').removeClass('selected');
      _this.addClass('selected');

      // Updated Hidden Select Field For Product Form JS
      $('option:selected', 'select[name="options[Colour]"]').removeAttr(
        'selected'
      );
      $(`option[value="${dataValue}"]`, 'select[name="options[Colour]"]').attr(
        'selected',
        true
      );

      let changeEvent = new Event('change');
      document
        .querySelector('[name="options[Colour]"]')
        .dispatchEvent(changeEvent);

      updateSlickSliderOnSwatchSelect(colourIndex, dataValue, swatchState);
      // updateProductImage(colourIndex, optionValue);
    });

    // ======================
    // UI Box Product Options
    // ======================
    $('.box-option').on('click', function () {
      let dataValue = $(this).data('size-value');

      // Updated Hidden Select Field For Product Form JS
      $('option:selected', 'select[name="options[Size]"]').removeAttr(
        'selected'
      );
      $('select[name="options[Size]"]')
        .find(`option[value="${dataValue}"]`)
        .attr('selected', true);

      let changeEvent = new Event('change');
      document
        .querySelector('[name="options[Size]"]')
        .dispatchEvent(changeEvent);

      $('.box-option').removeClass('selected');
      $(this).addClass('selected');
    });

    // =============================
    // Variant Quantity Options
    // it does two jobs, sync the hidden select, and fire the change event to trigger onOptionChange function
    // =============================
    $('.quantity-option').on('click', function () {
      // sync the hidden select
      const selectedQty = $(this).data('qty-value');
      const hiddenSelect = document.querySelector('[name="options[Qty]"]');
      $('option:selected', hiddenSelect).removeAttr('selected');
      $(`option[value="${selectedQty}"]`, hiddenSelect).attr('selected', true);

      // fire the change event from hidden select
      let changeEvent = new Event('change');
      document.querySelector('[name="options[Qty]"]').dispatchEvent(changeEvent);
      // update the UI
      // $('.quantity-option').removeClass('selected');
      // $(this).addClass('selected');
    });
  }

  // function addToCart(id, qty, properties = {}, options = {}) {
  //   CartJS.addItem(id, qty, properties, options);
  // }

  function handleQuantityInputChange(event) {
    var value = parseInt(els.quantityInput.value, 10);

    if (event.target.id == 'quantity-increase') {
      value = isNaN(value) ? 1 : value;
      value++;
    } else if (event.target.id == 'quantity-decrease') {
      value = isNaN(value) ? 1 : value;
      value--;
    }
    els.quantityInput.value = value < 2 ? 1 : value;

    // Update Chanage Event for Quantity Input
    let changeEvent = new Event('change');
    els.quantityInput.dispatchEvent(changeEvent);

  }

  function updateProductFormUIOnLoad(variant) {
    if (variant.options.length === 3) {
      // Colour
      // Maniplulate the UI
      $('[data-selected-colour]').text(variant.option1);
      $('.colour-option').removeClass('selected');
      $(`.colour-option[data-variant-id="${variant.id}"]`).addClass('selected');
      // Updated Hidden Select Field For Product Form JS
      $('option:selected', 'select[name="options[Colour]"]').removeAttr(
        'selected'
      );
      $(
        `option[value="${variant.option1}"]`,
        'select[name="options[Colour]"]'
      ).attr('selected', true);
    }

    // Length
    $(`select[data-length-field] > option`).removeAttr('selected');
    $(
      `select[data-length-field] > option[data-variant-id="${variant.id}"]`
    ).attr('selected', true);

    // Size
    $(`select[data-size-field] > option`).removeAttr('selected');
    $(`select[data-size-field] > option[data-variant-id="${variant.id}"]`).attr(
      'selected',
      true
    );

    updateProductOptionsv3(variant);
    updateSampleSelection();
  }

  function getSelectedVariant(variant) {
    const selectedSize = variant.options[sizeOrDenominationsIndex];
    return globalProductJSON.variants.filter(
      (variant) => variant.options[sizeOrDenominationsIndex] === selectedSize
    );
  }

  function getAvailableQtyOption(variant) {
    const availableVariants = getSelectedVariant(variant);
    return availableVariants.map((variant) => variant.options[qtyIndex]);
  }

  function updateProductOptionsv3(variant) {
    // Update product options UI
    const selectedSize = variant.options[sizeOrDenominationsIndex];
    const selectedColour = variant.options[colourIndex];
    const availbaleQtyOptions = getAvailableQtyOption(variant);

    $('.custom-styled-multioption').removeClass('selected');
    $('.custom-styled-multioption').each(function () {
      const qtyValue = $(this).data('qty-value');
      const sizeValue = $(this).data('size-value');
      const colourValue = $(this).data('colour-value');
      if (
        availbaleQtyOptions.includes(qtyValue) &&
        sizeValue === selectedSize &&
        colourValue === selectedColour
      ) {
        $(this).removeClass('hide');
      } else {
        $(this).addClass('hide');
      }
    });

    $('.custom-styled-multioption:not(".hide")').first().addClass('selected');
    const selectedVariant = getSelectedVariant(variant)[0];
    if (selectedVariant) {
      $('.custom-styled-multioption.selected .quantity_price').text(
        `$${selectedVariant.price / 100}`
      );
    }
    $('.custom-styled-multioption').click((e) => {
      $('.custom-styled-multioption').removeClass('selected');
      $(e.currentTarget).addClass('selected');
      const qty = $(e.currentTarget).data('qty-value');
      const selectedSize = variant.options[sizeOrDenominationsIndex];
      const selectedColour = variant.options[colourIndex];
      const selectedVariant = globalProductJSON.variants.find(
        (variant) =>
          variant.options[sizeOrDenominationsIndex] === selectedSize &&
          variant.options[colourIndex] === selectedColour &&
          variant.options[qtyIndex] === qty
      );
      if (selectedVariant) {
        setProductAvailablity(selectedVariant, qty, false);
        updateSalePriceAndHistory(selectedVariant);
      }
    });
    updateSalePriceAndHistory(selectedVariant);
  }

  function updateSalePriceAndHistory(variant) {
    // Check if Variant Exists
    // Update the Qty Variant Based on the Filtered Variant
    if (variant) {
      // Check if Product is on Sale
      updateToShowOnSaleUI(variant);

      // Update Global Variable
      selectedVariant = variant.id;
      currentProductPriceV2 = variant.price;
      compareAtPriceV2 = variant.compare_at_price;
      let getProductQuantity = shopifyProductForm.quantity();
      // Update Product Pricing
      updateProductPrices(
        getProductQuantity,
        currentProductPriceV2,
        compareAtPriceV2
      );

      // Update History
      updateWindowHistory(selectedVariant);
    } else {
      noVariantExists = true;
    }
  }

  function updateProductPrices(qty, price, compareAtPrice = null) {
    let currentPriceElement = $(els.form.price);
    let compareAtPriceElement = $(`${els.form.comparePrice} > s`);
    let updatedPrice = price * qty;
    let updatedCompareAtPrice = compareAtPrice * qty;

    // Update Global Variable
    productQuantity = qty;

    // Modify Prices
    currentPriceElement.text(currency.formatMoney(updatedPrice));
    compareAtPriceElement.text(currency.formatMoney(updatedCompareAtPrice));
  }

  function updateToShowOnSaleUI(variant) {
    if (variant.compare_at_price == null) {
      $('[data-compare-price]').addClass('hide');
      $('[data-sale-badge]').addClass('hide');
      $('[data-price]').removeClass('text--orange');

      // Update the PDP Details Banner
      // $('.product-hero__details-banner').addClass('hide');
    } else {
      $('[data-compare-price]').removeClass('hide');
      $('[data-sale-badge]').removeClass('hide');
      $('[data-price]').addClass('text--orange');

      // Update the PDP Details Banner
      // $('.product-hero__details-banner').removeClass('hide');
    }
  }

  function updateWindowHistory(variantID) {
    // Update History
    const url = getUrlWithVariant(window.location.href, variantID);
    window.history.replaceState({ path: url }, '', url);
  }

  function setProductAvailablity(variant, qty, updatePrice = true) {
    const addToCartBtn = els.form.addToCart;
    const addToCartText = els.form.addToCartText;
    const klaviyoBisButton = els.form.klaviyoBisButton;
    // ***** Updated Note *****
    // The combination of selected options does not have a matching variant
    // The ProductForm has a callback, and since we are programatically
    // Updating the 'QTY' product option, we will have a variant return null

    // It is possible for a customer to change the product options
    // and the combination of options does not return a Product Variant.
    // In this use case, we filter the product variants again and update the product form
    if (variant === null) {
      if (noVariantExists) {
        addToCartText.innerHTML = `Doesn\'t Exist`;
        addToCartBtn.disabled = true;
        klaviyoBisButton.style.display = 'none';
        if (updatePrice) updateProductPrices(qty, 0, 0);
      }
      // The combination of selected options has a matching variant but it is unavailable
    } else if (variant && !variant.available) {
      // Variant Recorded!! But, Variant Is Out Of Stock...
      addToCartText.innerHTML = `Out of Stock`;
      addToCartBtn.disabled = true;
      klaviyoBisButton.style.display = 'block';
      if (updatePrice)
        updateProductPrices(qty, variant.price, variant.compare_at_price);

      // The combination of selected options has a matching variant and it is available
    } else if (variant && variant.available) {
      // Variant Recorded!! Enable Add To Cart Button...
      addToCartText.innerHTML = `Add to Bag`;
      addToCartBtn.disabled = false;
      klaviyoBisButton.style.display = 'none';
      if (updatePrice) {
        updateProductPrices(qty, variant.price, variant.compare_at_price);

        // Update Global Variable
        selectedVariant = variant.id;
        compareAtPriceV2 = variant.compare_at_price;
        currentProductPriceV2 = variant.price;
      }
    }
  }

  function setKlaviyoOutOfStockModal() {
    var iframe = document.getElementById('klaviyo-bis-iframe');
    var sizeSelector = document.getElementById('PDP_Option2');
    var klaviyoBisTrigger = document.querySelector('.klaviyo-bis-trigger');

    function setSelectOptionByValue(elmnt, value) {
      for (var i = 0; i < elmnt.options.length; i++) {
        if (elmnt.options[i].value === value) {
          elmnt.selectedIndex = i;
          break;
        }
      }
    }

    function setSelectBox() {
      var SID =
        sizeSelector.options[sizeSelector.selectedIndex].dataset.variantId;
      var iframeDoc = iframe.contentWindow.document;
      var variantsSelector = iframeDoc.querySelector('#variants');
      setSelectOptionByValue(variantsSelector, SID);
      document.querySelector('#variants').value = SID;
    }

    function setModal() {
      setSelectBox();
    }

    klaviyoBisTrigger.addEventListener('click', () => {
      iframe.addEventListener('load', setModal, { once: true });
    });
  }

  function updateSlickSliderOnSwatchSelect(
    colourIndex,
    dataValue,
    swatchState
  ) {
    if (swatchState.hasImageAdded) {
      removeAddedSlideAndThumbnail(swatchState);
    }
    const optionIndex = 'option' + String(colourIndex + 1);
    const productVariants = globalProductJSON.variants.map(
      (variant) => variant
    );
    const selectedOptionWithVariantsImage = productVariants.filter(
      (variant) => {
        return variant[optionIndex] === dataValue && variant.featured_image;
      }
    );
    if (selectedOptionWithVariantsImage.length > 0) {
      const image = selectedOptionWithVariantsImage[0].featured_image;
      const newSlide = `<div class="product-hero__media-wrapper" data-product-hero-media-wrapper tabindex="-1">
    <div class="product-hero__slider-image">
      <img src="${image.src}" srcset="${image.src}" alt="${image.alt}">
    </div>
  </div>`;
      const newThumbnail = `<li class="product-hero__thumbnails-item product-hero__thumbnails-item--image">
      <span class="text-link product-hero__thumbnail">
        <img class="product-hero__thumbnail-image" src="${image.src}" width="110" height="auto" alt="${image.alt}">
      </span>
  </li>`;
      addColourOptionImageToSlider(newSlide, newThumbnail, swatchState);
    } else {
      if (swatchState.hasImageAdded) {
        removeAddedSlideAndThumbnail(swatchState);
      }
    }
  }

  // function to add Colour option image into the slick slider at index 0
  function addColourOptionImageToSlider(slide, thumbnail, swatchState) {
    $('.product-hero__slider-inner').slick('slickAdd', slide, 0, true);
    $('.product-hero__thumbnails').slick('slickAdd', thumbnail, 0, true);
    resizeSlider();
    $('.product-hero__slider-inner').slick('slickGoTo', 0, true);
    $('.product-hero__thumbnails').slick('slickGoTo', 0, true);
    swatchState.hasImageAdded = true;
  }

  // function to remove added slide and thumbnail when other colour swatch is clicked
  function removeAddedSlideAndThumbnail(swatchState) {
    $('.product-hero__slider-inner').slick('slickRemove', 0);
    $('.product-hero__thumbnails').slick('slickRemove', 0);
    swatchState.hasImageAdded = false;
  }

  // function to resize the slick slider//
  // this is needed due to slick slider not being able to wait for load of new slide to set .slick-list height
  function resizeSlider() {
    const sliderHeight = $('.product-hero__slider-inner')
      .find('.slick-track')
      .height();
    $('.product-hero__slider-inner')
      .find('.slick-list')
      .css('min-height', sliderHeight + 'px');
  }

  // ============================================================
  // TENA-692: Size Selector Image Variant Changer
  document.addEventListener('updateProductOptionsv3', function (event) {
    if (!event?.detail?.variant?.featured_image?.src) {
      return null;
    }

    // 0. Initial setup
    const sliderContainer = document.querySelector(
      '.product-hero__slider-inner'
    );

    function findSlide(src) {
      // 1. Find the image in slider by src
      const srcFilename = getImageFilenameWithoutExtension(src);
      if (!srcFilename) return null;

      const srcSelector = "img[src*='" + srcFilename + "']";
      const imageElement = sliderContainer.slick
        .getSlick()
        .$slides.find(srcSelector)[0];

      // 2. Find the image slide index by searching up the DOM tree for the nearest slide-index data attibute
      const index =
        imageElement.closest('[data-slick-index]').dataset.slickIndex;

      // 3. String to number + return
      return Number(index);
    }

    // 1. Get image src to slide to
    const variant = event.detail.variant;
    const featuredImageSrc = variant.featured_image.src;

    // 2. Find the slide number that contains the image src to go to
    const slideNumber = findSlide(featuredImageSrc);

    // 3. GO!
    if (slideNumber) {
      sliderContainer.slick.slickGoTo(slideNumber);
    }
  });
};

export default PDP;
